import type { CSSProperties, FunctionComponent } from 'react';

import { PowerUpIcon } from '@trello/nachos/icons/power-up';
import { token } from '@trello/theme';

import styles from './TemplatesPowerUpTile.less';

const getBackgroundStyle = (icon?: string) => {
  const css: CSSProperties = {};
  if (icon) {
    css.backgroundImage = `url('${icon}')`;
    css.backgroundSize = 'cover';
    css.backgroundPosition = 'center';
  }
  return css;
};

const renderPowerUpIcon = (icon?: string) => {
  if (!icon) {
    return (
      <PowerUpIcon
        dangerous_className={styles.defaultIcon}
        color={token('color.icon.accent.blue', '#1D7AFC')}
      />
    );
  } else {
    const iconStyle = getBackgroundStyle(icon);
    return <div className={styles.icon} style={iconStyle} />;
  }
};

export const TemplatesPowerUpTile: FunctionComponent<{
  icon?: string;
  name: string;
  description: string;
}> = ({ icon, name, description }) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleArea}>
        {renderPowerUpIcon(icon)}
        <div className={styles.name}>{name}</div>
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};
